import React, {ReactNode} from "react";
import {ViewerMode} from "./ViewerMode";
import Translate from "../../shared/translation/Translate";
import {I18nGlobals} from "../../shared/translation/i18nInterface";
import PortalPureComponent from "../../shared/components/PortalPureComponent";

export interface LoadingViewerProperties extends I18nGlobals {
	viewerMode: ViewerMode;
}

export default class LoadingViewer extends PortalPureComponent<LoadingViewerProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		return (
			<div className="viewer loading">
				{
					(
						this.props.viewerMode === ViewerMode.DEFAULT
					) ?
						<div className="loader active">
							<span className="icon icon-gear spin"/>
							<p>
								<Translate {...this.props} data="viewerscreen.message.locked" namespace="screen"/>
							</p>
						</div> :
						<div className="loader active tooltip" data-pr-position={"right"}
							 data-pr-tooltip={Translate.value(
								 "viewerscreen.message.locked", {ns: "screen"}
							 )}>
							<span className="icon icon-gear spin"/>
						</div>
				}
			</div>
		);
	}
}